module.exports = __webpack_public_path__ + "img/41ne.5b8d9b82.svg";